module.exports = __webpack_public_path__ + "img/Apoptosis-OVCA_GSE227019.04fdce86.png";